import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form';
import { StanTipTapEditorCompact } from '@/components';
import { TemplateVariables } from '../emails/types';

interface EmailSubjectFieldProps<T extends FieldValues> {
    control: Control<T>;
    errors: FieldErrors<T>;
    disabled?: boolean;
    templateVariables?: TemplateVariables | null;
    onSubjectChange?: (subject: string) => void;
}

export const EmailSubjectField = <T extends FieldValues & { subject: string }>({
    control,
    errors,
    disabled = false,
    templateVariables,
    onSubjectChange,
}: EmailSubjectFieldProps<T>) => {
    return (
        <div className='space-y-2'>
            <label className='text-label-xs-bold block'>Email Subject</label>
            <Controller
                name={'subject' as Path<T>}
                control={control}
                render={({ field }) => (
                    <StanTipTapEditorCompact
                        value={field.value as string}
                        onChange={value => {
                            field.onChange(value);
                            onSubjectChange?.(value);
                        }}
                        error={!!errors.subject}
                        disabled={disabled}
                        personalizeItemData={
                            templateVariables?.subject?.map(v => ({
                                name: v.name,
                                id: v.id,
                                required: v.required,
                            })) || []
                        }
                        placeholder='Write your email subject here...'
                    />
                )}
            />
            {errors.subject && (
                <p className='text-negative-active text-label-xs-bold'>{String(errors.subject.message || '')}</p>
            )}
        </div>
    );
};
